import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { InputComponent } from './input/input.component';
import { TextareaComponent } from './textarea/textarea.component';
import { SelectComponent } from './select/select.component';
import { TagSelectComponent } from './tag-select/tag-select.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { CheckboxTreeComponent } from './checkbox-tree/checkbox-tree.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { ToggleComponent } from './toggle/toggle.component';
import { BadgeComponent } from './badge/badge.component';
import { MenuButtonComponent } from './menu-button/menu-button.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { KtSelectPanelDirective } from './select/select-panel.directive';
import { ButtonComponent } from './button/button.component';
import { ChipComponent } from './chip/chip.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DropdownSingleSelectComponent } from './dropdown-single-select/dropdown-single-select.component';
import { ButtonToggleGroupComponent } from './button-toggle-group/button-toggle-group.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';

const PRIMITIVES = [
  InputComponent,
  TextareaComponent,
  SelectComponent,
  TagSelectComponent,
  CheckboxComponent,
  CheckboxGroupComponent,
  CheckboxTreeComponent,
  RadioGroupComponent,
  ToggleComponent,
  BadgeComponent,
  MenuButtonComponent,
  DatePickerComponent,
  DateRangePickerComponent,
  KtSelectPanelDirective,
  ButtonComponent,
  ChipComponent,
  DropdownComponent,
  DropdownSingleSelectComponent,
  ButtonToggleGroupComponent,
  ColorPickerComponent,
];

@NgModule({
  declarations: PRIMITIVES,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OverlayModule,
    ScrollingModule,
    NgxMatSelectSearchModule,
  ],
  exports: PRIMITIVES,
})
export class PrimitivesModule { }
